// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Admin Dashboard Layout Styles */

.admin-dashboard-layout {
    min-height: 100vh;
    display: flex;
    background: #f8fafc;
}

/* Sidebar Styling */
.admin-sidebar {
    width: 250px;
    background: white;
    border-right: 1px solid #e2e8f0;
    display: flex;
    flex-direction: column;
    position: fixed;
    left: 0;
    top: 0;
    height: 100vh;
    z-index: 100;
    overflow-y: auto;
    flex-shrink: 0;
    transition: width 0.3s ease;
}

.admin-sidebar.collapsed {
    width: 70px;
}

.admin-sidebar.collapsed .admin-sidebar-title,
.admin-sidebar.collapsed .menu-section-label {
    display: none;
}

.admin-sidebar.collapsed .sidebar-menu-item {
    justify-content: center;
    padding: 0.75rem;
}

.admin-sidebar.collapsed .sidebar-menu-item .menu-icon {
    display: block;
    margin: 0;
}

.admin-sidebar.collapsed .sidebar-menu-item span:not(.menu-icon) {
    display: none !important;
}

.admin-sidebar.collapsed .admin-sidebar-header {
    justify-content: center;
    padding: 1rem;
}

.admin-sidebar.collapsed .sidebar-logout-btn {
    justify-content: center;
    padding: 0.75rem;
}

.admin-sidebar-header {
    padding: 1.5rem;
    display: flex;
    align-items: center;
    gap: 1rem;
    border-bottom: 1px solid #f1f5f9;
    cursor: pointer;
}

.admin-sidebar-logo-img {
    height: 32px;
}

.admin-sidebar-title h2 {
    margin: 0;
    font-size: 1.1rem;
    color: #1a202c;
    font-weight: 700;
}

.admin-sidebar-title span {
    font-size: 0.75rem;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.admin-sidebar-menu {
    flex: 1 1;
    padding: 1.5rem 1rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.menu-section-label {
    padding: 0 0.5rem 0.5rem;
    font-size: 0.7rem;
    font-weight: 600;
    color: #94a3b8;
    text-transform: uppercase;
    letter-spacing: 1px;
    margin-top: 1rem;
}

.menu-section-label:first-child {
    margin-top: 0;
}

.sidebar-menu-item {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.75rem 1rem;
    border: none;
    background: transparent;
    color: #64748b;
    font-weight: 600;
    font-size: 0.9rem;
    cursor: pointer;
    border-radius: 8px;
    transition: all 0.2s ease;
    width: 100%;
    text-align: left;
}

.sidebar-menu-item:hover {
    background: #f1f5f9;
    color: #667eea;
}

.sidebar-menu-item.active {
    background: #f0f4ff;
    color: #667eea;
}

.menu-icon {
    font-size: 1.25rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 24px;
}

.admin-sidebar-footer {
    padding: 1rem;
    border-top: 1px solid #f1f5f9;
}

.sidebar-logout-btn {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.75rem 1rem;
    width: 100%;
    border: none;
    background: #fff1f0;
    color: #f5222d;
    font-weight: 600;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.sidebar-logout-btn:hover {
    background: #ffccc7;
}

/* Sidebar Toggle Button */
.sidebar-toggle-btn {
    position: absolute;
    right: -15px;
    top: 50%;
    transform: translateY(-50%);
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: white;
    border: 1px solid #e2e8f0;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    color: #64748b;
}

.sidebar-toggle-btn:hover {
    background: #f8fafc;
    border-color: #cbd5e0;
    color: #667eea;
}

/* Main Container */
.admin-main-container {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    min-width: 0;
    margin-left: 250px;
    background: #f8fafc;
    transition: margin-left 0.3s ease;
}

.admin-sidebar.collapsed~.admin-main-container {
    margin-left: 70px;
}

/* Top Header */
.admin-top-header {
    height: 70px;
    background: white;
    border-bottom: 1px solid #e2e8f0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 2rem;
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 90;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.active-tab-title {
    font-size: 1.25rem;
    font-weight: 700;
    color: #1a202c;
    margin: 0;
}

.header-right {
    display: flex;
    align-items: center;
    gap: 1.5rem;
}

/* Reusing existing component styles but adapting to sidebar */

/* Role Badge */
.role-badge {
    padding: 0.5rem 1rem;
    border-radius: 20px;
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.role-badge.super-admin {
    background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
    color: white;
}

.admin-nav-icon-btn {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    color: #64748b;
}

.admin-nav-icon-btn:hover {
    background: #f1f5f9;
    border-color: #cbd5e0;
}

/* Main content padding */
.admin-dashboard-main {
    padding: 2rem;
    flex: 1 1;
    overflow-y: auto;
    overflow-x: hidden;
    background: #f8fafc;
}

/* Dropdowns & Modals (adapted from previous) */
.admin-dropdown-panel {
    position: absolute;
    top: 65px;
    right: 2rem;
    background: white;
    border-radius: 12px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
    min-width: 280px;
    padding: 1.5rem;
    z-index: 1000;
}

.admin-profile-header {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding-bottom: 1rem;
    border-bottom: 1px solid #f1f5f9;
}

.admin-profile-avatar {
    width: 45px;
    height: 45px;
    border-radius: 10px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
}

.admin-profile-info h3 {
    margin: 0;
    font-size: 1rem;
}

.admin-profile-info p {
    margin: 0;
    font-size: 0.85rem;
    color: #64748b;
}

.admin-detail-row {
    display: flex;
    justify-content: space-between;
    padding: 0.75rem 0;
}

.admin-detail-label {
    font-size: 0.85rem;
    color: #64748b;
}

.admin-detail-value {
    font-size: 0.85rem;
    font-weight: 600;
}

/* Profile Actions */
.admin-profile-actions {
    margin-top: 1rem;
    padding-top: 1rem;
    border-top: 1px solid #f1f5f9;
}

.admin-profile-logout-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    width: 100%;
    padding: 0.75rem;
    border: none;
    background: linear-gradient(135deg, #ff6b6b 0%, #ff5252 100%);
    color: white;
    font-weight: 600;
    font-size: 0.9rem;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(255, 107, 107, 0.2);
}

.admin-profile-logout-btn:hover {
    background: linear-gradient(135deg, #ff5252 0%, #ff3838 100%);
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(255, 107, 107, 0.3);
}

.admin-profile-logout-btn:active {
    transform: translateY(0);
}


.admin-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    -webkit-backdrop-filter: blur(4px);
            backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2000;
}

.admin-modal-content {
    background: white;
    border-radius: 16px;
    padding: 2rem;
    max-width: 400px;
    width: 90%;
    text-align: center;
}

.admin-modal-actions {
    display: flex;
    gap: 1rem;
    margin-top: 1.5rem;
}

.admin-modal-btn {
    flex: 1 1;
    padding: 0.75rem;
    border-radius: 8px;
    border: none;
    font-weight: 600;
    cursor: pointer;
}

.admin-modal-btn.confirm {
    background: #667eea;
    color: white;
}

.admin-modal-btn.cancel {
    background: #f1f5f9;
    color: #64748b;
}

/* Responsive */
@media (max-width: 1024px) {
    .admin-sidebar {
        width: 80px;
    }

    .admin-main-container {
        margin-left: 80px;
    }

    .admin-sidebar-title,
    .menu-section-label,
    .sidebar-menu-item span:not(.menu-icon),
    .sidebar-logout-btn span {
        display: none;
    }

    .sidebar-menu-item {
        justify-content: center;
        padding: 1rem;
    }

    .admin-sidebar-header {
        @media (max-width: 768px) {
            .admin-sidebar {
                width: 250px;
                transform: translateX(-100%);
                transition: transform 0.3s ease;
            }

            .admin-sidebar.open {
                transform: translateX(0);
            }

            .admin-main-container {
                margin-left: 0;
            }
        }

        justify-content: center;
        padding: 1rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/AdminDashboardLayout.css"],"names":[],"mappings":"AAAA,kCAAkC;;AAElC;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;AACvB;;AAEA,oBAAoB;AACpB;IACI,YAAY;IACZ,iBAAiB;IACjB,+BAA+B;IAC/B,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,OAAO;IACP,MAAM;IACN,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,SAAS;AACb;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,SAAO;IACP,oBAAoB;IACpB,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,wBAAwB;IACxB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;IACrB,YAAY;IACZ,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA,0BAA0B;AAC1B;IACI,kBAAkB;IAClB,YAAY;IACZ,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,yBAAyB;IACzB,wCAAwC;IACxC,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA,mBAAmB;AACnB;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,iCAAiC;AACrC;;AAEA;IACI,iBAAiB;AACrB;;AAEA,eAAe;AACf;IACI,YAAY;IACZ,iBAAiB;IACjB,gCAAgC;IAChC,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,wBAAgB;IAAhB,gBAAgB;IAChB,MAAM;IACN,WAAW;IACX,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA,8DAA8D;;AAE9D,eAAe;AACf;IACI,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,6DAA6D;IAC7D,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,SAAO;IACP,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA,+CAA+C;AAC/C;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,0CAA0C;IAC1C,gBAAgB;IAChB,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,6DAA6D;IAC7D,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,oBAAoB;AACpB;IACI,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,6DAA6D;IAC7D,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,8CAA8C;AAClD;;AAEA;IACI,6DAA6D;IAC7D,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA;IACI,wBAAwB;AAC5B;;;AAGA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,kCAA0B;YAA1B,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,eAAe;AACf;IACI;QACI,WAAW;IACf;;IAEA;QACI,iBAAiB;IACrB;;IAEA;;;;QAII,aAAa;IACjB;;IAEA;QACI,uBAAuB;QACvB,aAAa;IACjB;;IAEA;QACI;YACI;gBACI,YAAY;gBACZ,4BAA4B;gBAC5B,+BAA+B;YACnC;;YAEA;gBACI,wBAAwB;YAC5B;;YAEA;gBACI,cAAc;YAClB;QACJ;;QAEA,uBAAuB;QACvB,aAAa;IACjB;AACJ","sourcesContent":["/* Admin Dashboard Layout Styles */\n\n.admin-dashboard-layout {\n    min-height: 100vh;\n    display: flex;\n    background: #f8fafc;\n}\n\n/* Sidebar Styling */\n.admin-sidebar {\n    width: 250px;\n    background: white;\n    border-right: 1px solid #e2e8f0;\n    display: flex;\n    flex-direction: column;\n    position: fixed;\n    left: 0;\n    top: 0;\n    height: 100vh;\n    z-index: 100;\n    overflow-y: auto;\n    flex-shrink: 0;\n    transition: width 0.3s ease;\n}\n\n.admin-sidebar.collapsed {\n    width: 70px;\n}\n\n.admin-sidebar.collapsed .admin-sidebar-title,\n.admin-sidebar.collapsed .menu-section-label {\n    display: none;\n}\n\n.admin-sidebar.collapsed .sidebar-menu-item {\n    justify-content: center;\n    padding: 0.75rem;\n}\n\n.admin-sidebar.collapsed .sidebar-menu-item .menu-icon {\n    display: block;\n    margin: 0;\n}\n\n.admin-sidebar.collapsed .sidebar-menu-item span:not(.menu-icon) {\n    display: none !important;\n}\n\n.admin-sidebar.collapsed .admin-sidebar-header {\n    justify-content: center;\n    padding: 1rem;\n}\n\n.admin-sidebar.collapsed .sidebar-logout-btn {\n    justify-content: center;\n    padding: 0.75rem;\n}\n\n.admin-sidebar-header {\n    padding: 1.5rem;\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    border-bottom: 1px solid #f1f5f9;\n    cursor: pointer;\n}\n\n.admin-sidebar-logo-img {\n    height: 32px;\n}\n\n.admin-sidebar-title h2 {\n    margin: 0;\n    font-size: 1.1rem;\n    color: #1a202c;\n    font-weight: 700;\n}\n\n.admin-sidebar-title span {\n    font-size: 0.75rem;\n    color: #64748b;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.admin-sidebar-menu {\n    flex: 1;\n    padding: 1.5rem 1rem;\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n}\n\n.menu-section-label {\n    padding: 0 0.5rem 0.5rem;\n    font-size: 0.7rem;\n    font-weight: 600;\n    color: #94a3b8;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n    margin-top: 1rem;\n}\n\n.menu-section-label:first-child {\n    margin-top: 0;\n}\n\n.sidebar-menu-item {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    padding: 0.75rem 1rem;\n    border: none;\n    background: transparent;\n    color: #64748b;\n    font-weight: 600;\n    font-size: 0.9rem;\n    cursor: pointer;\n    border-radius: 8px;\n    transition: all 0.2s ease;\n    width: 100%;\n    text-align: left;\n}\n\n.sidebar-menu-item:hover {\n    background: #f1f5f9;\n    color: #667eea;\n}\n\n.sidebar-menu-item.active {\n    background: #f0f4ff;\n    color: #667eea;\n}\n\n.menu-icon {\n    font-size: 1.25rem;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 24px;\n}\n\n.admin-sidebar-footer {\n    padding: 1rem;\n    border-top: 1px solid #f1f5f9;\n}\n\n.sidebar-logout-btn {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    padding: 0.75rem 1rem;\n    width: 100%;\n    border: none;\n    background: #fff1f0;\n    color: #f5222d;\n    font-weight: 600;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.sidebar-logout-btn:hover {\n    background: #ffccc7;\n}\n\n/* Sidebar Toggle Button */\n.sidebar-toggle-btn {\n    position: absolute;\n    right: -15px;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 30px;\n    height: 30px;\n    border-radius: 50%;\n    background: white;\n    border: 1px solid #e2e8f0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n    color: #64748b;\n}\n\n.sidebar-toggle-btn:hover {\n    background: #f8fafc;\n    border-color: #cbd5e0;\n    color: #667eea;\n}\n\n/* Main Container */\n.admin-main-container {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n    margin-left: 250px;\n    background: #f8fafc;\n    transition: margin-left 0.3s ease;\n}\n\n.admin-sidebar.collapsed~.admin-main-container {\n    margin-left: 70px;\n}\n\n/* Top Header */\n.admin-top-header {\n    height: 70px;\n    background: white;\n    border-bottom: 1px solid #e2e8f0;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0 2rem;\n    position: sticky;\n    top: 0;\n    z-index: 90;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.active-tab-title {\n    font-size: 1.25rem;\n    font-weight: 700;\n    color: #1a202c;\n    margin: 0;\n}\n\n.header-right {\n    display: flex;\n    align-items: center;\n    gap: 1.5rem;\n}\n\n/* Reusing existing component styles but adapting to sidebar */\n\n/* Role Badge */\n.role-badge {\n    padding: 0.5rem 1rem;\n    border-radius: 20px;\n    font-size: 0.75rem;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.role-badge.super-admin {\n    background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);\n    color: white;\n}\n\n.admin-nav-icon-btn {\n    width: 40px;\n    height: 40px;\n    border-radius: 10px;\n    background: #f8fafc;\n    border: 1px solid #e2e8f0;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.2s ease;\n    color: #64748b;\n}\n\n.admin-nav-icon-btn:hover {\n    background: #f1f5f9;\n    border-color: #cbd5e0;\n}\n\n/* Main content padding */\n.admin-dashboard-main {\n    padding: 2rem;\n    flex: 1;\n    overflow-y: auto;\n    overflow-x: hidden;\n    background: #f8fafc;\n}\n\n/* Dropdowns & Modals (adapted from previous) */\n.admin-dropdown-panel {\n    position: absolute;\n    top: 65px;\n    right: 2rem;\n    background: white;\n    border-radius: 12px;\n    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);\n    min-width: 280px;\n    padding: 1.5rem;\n    z-index: 1000;\n}\n\n.admin-profile-header {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    padding-bottom: 1rem;\n    border-bottom: 1px solid #f1f5f9;\n}\n\n.admin-profile-avatar {\n    width: 45px;\n    height: 45px;\n    border-radius: 10px;\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    color: white;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: 700;\n}\n\n.admin-profile-info h3 {\n    margin: 0;\n    font-size: 1rem;\n}\n\n.admin-profile-info p {\n    margin: 0;\n    font-size: 0.85rem;\n    color: #64748b;\n}\n\n.admin-detail-row {\n    display: flex;\n    justify-content: space-between;\n    padding: 0.75rem 0;\n}\n\n.admin-detail-label {\n    font-size: 0.85rem;\n    color: #64748b;\n}\n\n.admin-detail-value {\n    font-size: 0.85rem;\n    font-weight: 600;\n}\n\n/* Profile Actions */\n.admin-profile-actions {\n    margin-top: 1rem;\n    padding-top: 1rem;\n    border-top: 1px solid #f1f5f9;\n}\n\n.admin-profile-logout-btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n    width: 100%;\n    padding: 0.75rem;\n    border: none;\n    background: linear-gradient(135deg, #ff6b6b 0%, #ff5252 100%);\n    color: white;\n    font-weight: 600;\n    font-size: 0.9rem;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    box-shadow: 0 2px 8px rgba(255, 107, 107, 0.2);\n}\n\n.admin-profile-logout-btn:hover {\n    background: linear-gradient(135deg, #ff5252 0%, #ff3838 100%);\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(255, 107, 107, 0.3);\n}\n\n.admin-profile-logout-btn:active {\n    transform: translateY(0);\n}\n\n\n.admin-modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.4);\n    backdrop-filter: blur(4px);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 2000;\n}\n\n.admin-modal-content {\n    background: white;\n    border-radius: 16px;\n    padding: 2rem;\n    max-width: 400px;\n    width: 90%;\n    text-align: center;\n}\n\n.admin-modal-actions {\n    display: flex;\n    gap: 1rem;\n    margin-top: 1.5rem;\n}\n\n.admin-modal-btn {\n    flex: 1;\n    padding: 0.75rem;\n    border-radius: 8px;\n    border: none;\n    font-weight: 600;\n    cursor: pointer;\n}\n\n.admin-modal-btn.confirm {\n    background: #667eea;\n    color: white;\n}\n\n.admin-modal-btn.cancel {\n    background: #f1f5f9;\n    color: #64748b;\n}\n\n/* Responsive */\n@media (max-width: 1024px) {\n    .admin-sidebar {\n        width: 80px;\n    }\n\n    .admin-main-container {\n        margin-left: 80px;\n    }\n\n    .admin-sidebar-title,\n    .menu-section-label,\n    .sidebar-menu-item span:not(.menu-icon),\n    .sidebar-logout-btn span {\n        display: none;\n    }\n\n    .sidebar-menu-item {\n        justify-content: center;\n        padding: 1rem;\n    }\n\n    .admin-sidebar-header {\n        @media (max-width: 768px) {\n            .admin-sidebar {\n                width: 250px;\n                transform: translateX(-100%);\n                transition: transform 0.3s ease;\n            }\n\n            .admin-sidebar.open {\n                transform: translateX(0);\n            }\n\n            .admin-main-container {\n                margin-left: 0;\n            }\n        }\n\n        justify-content: center;\n        padding: 1rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
